import React from "react";
import { ControllerEliminarDiagnosticoPaciente } from "../../../Service/Service.diagnostico";
import { Section } from "../HCPiezas";

/* ============================================================================
   Pestaña «Diagnóstico» de las órdenes y los certificados.

   No es un formulario nuevo: muestra los diagnósticos que YA tiene la consulta.
   Se comparte entre los cinco modales que la llevan, en vez de repetir la misma
   tabla cinco veces (que es lo que hacían los modales viejos).
   ========================================================================== */
export default function TabDiagnosticos({ diagnosticos = [], onRefrescar }) {
  const quitar = async (id) => {
    const r = await ControllerEliminarDiagnosticoPaciente(id);
    if (r && r.success && onRefrescar) await onRefrescar();
  };

  return (
    <Section title="Diagnósticos de esta consulta" hint="Se registran en la consulta, no aquí.">
      {diagnosticos.length === 0 ? (
        <div className="hclist__vacio">
          Aún no hay diagnósticos en esta consulta. Se agregan en la sección Diagnósticos de la hoja.
        </div>
      ) : (
        <div className="hcya">
          {diagnosticos.map((d) => (
            <div className="hcya__fila" key={d.iddiagnostico_cita_paciente}>
              <span className="hcauto__cod">{d.diagnostico?.codigo}</span>
              <span className="hcya__nom">{d.diagnostico?.nombre}</span>
              {d.typo_diagnostico && (
                <span className="hcya__tipo">{String(d.typo_diagnostico).toLowerCase()}</span>
              )}
              <button
                type="button"
                className="hcauto__quitar"
                aria-label={`Quitar ${d.diagnostico?.codigo}`}
                title="Quitar de la consulta"
                onClick={() => quitar(d.iddiagnostico_cita_paciente)}
              >
                🗑
              </button>
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
